
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ir/calendar",
      function () {
        return require("private-next-pages/ir/calendar/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ir/calendar"])
      });
    }
  